import SectionLabel from "./SectionLabel";

export default function PageHero({
  eyebrowNumber = "01",
  eyebrow,
  title,
  highlight,
  tagline,
  description,
  pageTitle,
}) {
  // Document title is owned by <Seo /> (per-route SEO config).
  // pageTitle is kept as a prop for backward compatibility but ignored here.
  void pageTitle;

  return (
    <section
      data-testid="page-hero"
      className="spotlight-hero relative overflow-hidden border-b border-slate-soft"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 lg:py-20 relative z-10">
        <div className="max-w-4xl">
          {eyebrow && <SectionLabel number={eyebrowNumber}>{eyebrow}</SectionLabel>}
          <h1
            data-testid="page-hero-title"
            className="font-bebas text-white text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight animate-fade-up"
          >
            {title}
            {highlight && (
              <>
                {" "}
                <span className="gold-text">{highlight}</span>
              </>
            )}
          </h1>
          {tagline && (
            <p className="font-cormorant text-2xl sm:text-3xl text-gold-bright/90 mt-6 max-w-2xl animate-fade-up stagger-1">
              {tagline}
            </p>
          )}
          {description && (
            <p className="font-manrope text-soft-gray text-base sm:text-lg mt-6 max-w-2xl leading-relaxed animate-fade-up stagger-2">
              {description}
            </p>
          )}
        </div>
      </div>
      {/* faint stage line */}
      <div className="absolute left-0 right-0 bottom-0 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" />
    </section>
  );
}
